<template>
  <span class="employee-highlight-audit-change">
    <template v-if="single">
      <EmployeeHighlightChip :color="singleColor" />
    </template>
    <template v-else>
      <EmployeeHighlightChip :color="oldColor" />
      <i class="pi pi-arrow-right employee-highlight-audit-change__arrow" aria-hidden="true"></i>
      <EmployeeHighlightChip :color="newColor" />
    </template>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import EmployeeHighlightChip from '@/components/employees/EmployeeHighlightChip.vue';
import { auditChangeIsSingleValue } from '@/components/employees/profile/utils/auditDisplayUtils';

defineOptions({ name: 'EmployeeHighlightAuditChange' });

const props = defineProps({
  entry: { type: Object, required: true }
});

const single = computed(() => auditChangeIsSingleValue(props.entry));

const oldColor = computed(() => String(props.entry?.old_value || ''));
const newColor = computed(() => String(props.entry?.new_value || ''));

const singleColor = computed(() => (
  oldColor.value && oldColor.value !== '—' ? oldColor.value : newColor.value
));
</script>

<style scoped>
.employee-highlight-audit-change {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
  flex-wrap: wrap;
}

.employee-highlight-audit-change__arrow {
  font-size: 0.6rem;
  color: var(--crc-text-muted, #9ca3af);
}
</style>
